import { API_MESSAGE_TYPE } from './types';

export const getResponseType = (response) => {

    if ((response && response.chatId) || (response && response._source === 'CHAT')) {
        return API_MESSAGE_TYPE.CHAT;
    }
    else if (response && response.engagementID) {
        return API_MESSAGE_TYPE.BOT;
    }
    else {
        return API_MESSAGE_TYPE.UNDEFINED;
    }

};

export const getRequestType = (parameters) => {

    if (parameters
        && parameters.message
        && Array.isArray(parameters.message)) {
        return API_MESSAGE_TYPE.BOT;
    }
    else {
        return API_MESSAGE_TYPE.CHAT;
    }

};
